export default __webpack_public_path__ + "static/media/700.d1062e63.woff";